import {Component, h, Prop, State} from '@stencil/core';
import {t} from "../../../redux/utils";

@Component({
    tag: 'rentware-secure',
    styleUrl: 'style.sass',
    shadow: true,
})
export class RentwareSecure {
    @Prop() secureTitle: string;
    @Prop() goBackText: string;

    @State() showDetails: boolean = false;

    handleBackButtonClick = () => {
        this.showDetails = false;
    }

    handleTextClick = () => {
        this.showDetails = true;
    }

    get secureByText() {
        return t('secure.dataSecured');
    }

    render() {
        return (
            <div class="SecureContainer">
                {this.showDetails &&
                    <rentware-secure-details
                        onBackButtonClick={this.handleBackButtonClick}
                        secureTitle={this.secureTitle}
                        goBackText={this.goBackText}
                    />
                }

                <div class="SecureText" onClick={this.handleTextClick}>
                    {this.secureByText}
                </div>
            </div>
        )

    }
}
